<template>
  <div class="lida-menu-wrapper">
    <el-menu
      :default-active="activeMenu"
      class="lida-el-menu"
      :collapse="collapsed"
      background-color="#FFF"
      text-color="#666666"
      active-text-color="#00a39e"
      @select="handleMenuSelect"
    >
      <template v-for="item in getMenus" :key="item.module">
        <!-- 有子菜单的项 -->
        <el-sub-menu
          v-if="item.children && item.children.length"
          :index="item.module"
          :popper-append-to-body="false"
          popper-class="hide-element-popup"
          @mouseenter.native="handleSubMenuEnter(item, $event)"
          @mouseleave.native="handleSubMenuLeave(item)"
        >
          <template #title>
            <img
              v-if="item.icon"
              :src="getMenuIcon(item, hoveredMenuModule === item.module)"
              class="menu-icon"
              alt=""
            />
            <span>{{ item.name }}</span>
          </template>
          <template v-for="son in item.children" :key="son.name">
            <el-menu-item v-for="col in son.children" :key="col.url" :index="col.url">
              {{ col.name }}
            </el-menu-item>
          </template>
        </el-sub-menu>

        <!-- 没有子菜单的项 -->
        <el-menu-item
          v-else
          :index="item.url"
          :key="item.module"
          @mouseenter.native="hoveredMenuModule = item.module"
          @mouseleave.native="hoveredMenuModule = null"
        >
          <img v-if="item.icon" :src="getMenuIcon(item, hoveredMenuModule === item.module)" class="menu-icon" alt="" />
          <span>{{ item.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>

    <!-- 自定义悬浮菜单 -->
    <div
      v-if="collapsed && showCustomPopup && currentHoverMenu"
      class="custom-popup-menu"
      :style="popupStyle"
      @mouseenter="handlePopupEnter"
      @mouseleave="handlePopupLeave"
    >
      <div class="popup-title">
        <img v-if="currentHoverMenu.icon" :src="getMenuIcon(currentHoverMenu)" class="menu-icon" alt="" />
        <span>{{ currentHoverMenu.name }}</span>
      </div>
      <div class="popup-divider"></div>
      <div class="popup-items">
        <template v-for="son in currentHoverMenu.children" :key="son.name">
          <div
            v-for="col in son.children"
            :key="col.url"
            class="popup-item"
            :class="{ 'is-active': col.url === activeMenu }"
            @click="handlePopupItemClick(col)"
          >
            {{ col.name }}
          </div>
        </template>
      </div>
    </div>

    <div class="menu-footer" :class="{ collapsed: collapsed }">
      <div class="settings-btn" @click="goToCompanyInfo">
        <img src="@/assets/icons/menu/set.png" class="footer-icon" alt="设置" />
      </div>
      <div v-if="!collapsed" class="divider"></div>
      <div class="toggle-btn" @click="toggleCollapse">
        <img src="@/assets/icons/menu/hide.png" class="footer-icon" :class="{ 'is-expand-icon': collapsed }" alt="收起" />
        <span v-if="!collapsed">收起菜单</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import menuData from '@/common/js/menuData.js'

export default {
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menus: menuData,
      showCustomPopup: false,
      currentHoverMenu: null,
      popupStyle: {},
      hoverTimer: null,
      hoveredMenuModule: null // 记录当前 hover 的菜单模块
    }
  },
  methods: {
    ...mapActions('systemModule', ['getUserInfo']),
    ...mapMutations('homeModule', ['setUserInfos']),

    handleMenuSelect(index) {
      if (index && index !== '') {
        this.$router.push({
          path: index,
          query: {}
        })
      }
    },

    handleMenuClick(row) {
      if (row.url) {
        this.$router.push({
          path: row.url,
          query: row.query || {}
        })
      }
    },

    getClass(item) {
      if (this.isPurchase && item.module === 'purchase') return 'active-menu-item'
      if (this.isPurchase && item.module === 'mysale') return ''
      if (item.url === this.getPath) return 'active-menu-item'
      if (JSON.stringify(item).includes(this.$route.fullPath)) return 'active-menu-item'
      return ''
    },

    toggleCollapse() {
      this.$emit('toggle-collapse')
    },

    handleSubMenuEnter(item, event) {
      // 设置 hover 状态
      this.hoveredMenuModule = item.module

      if (!this.collapsed) return

      console.log('handleSubMenuEnter', item)

      // 在 setTimeout 之前保存元素引用和位置信息
      const target = event.currentTarget
      if (!target) return

      const rect = target.getBoundingClientRect()

      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(() => {
        this.currentHoverMenu = { ...item }
        this.popupStyle = {
          top: `${rect.top}px`,
          left: `${rect.right + 4}px`
        }
        this.showCustomPopup = true

        console.log('Popup shown:', this.currentHoverMenu, this.popupStyle)
      }, 200)
    },

    handleSubMenuLeave(item) {
      // 清除 hover 状态
      if (this.hoveredMenuModule === item.module) {
        this.hoveredMenuModule = null
      }

      if (!this.collapsed) return

      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(() => {
        this.showCustomPopup = false
      }, 200)
    },

    handlePopupEnter() {
      clearTimeout(this.hoverTimer)
    },

    handlePopupLeave() {
      this.showCustomPopup = false
      this.currentHoverMenu = null
    },

    handlePopupItemClick(item) {
      this.showCustomPopup = false
      this.handleMenuClick(item)
    },

    // 获取菜单图标
    getMenuIcon(item, isHovered = false) {
      if (!item.icon) return ''

      // 判断是否为激活状态或 hover 状态
      const isActive = this.isMenuActive(item)
      const shouldHighlight = isActive || isHovered
      const iconName = shouldHighlight ? `${item.icon}-active` : item.icon

      try {
        return require(`@/assets/icons/menu/${iconName}.png`)
      } catch (e) {
        // 如果激活状态图标不存在，尝试使用默认图标
        if (shouldHighlight) {
          try {
            return require(`@/assets/icons/menu/${item.icon}.png`)
          } catch (e2) {
            // 默认图标也不存在，返回空
            return ''
          }
        }
        return ''
      }
    },

    // 判断菜单是否激活
    isMenuActive(item) {
      const currentPath = this.$route.path

      // 如果有直接的 url，判断当前路由是否匹配
      if (item.url) {
        return currentPath === item.url
      }

      // 如果有子菜单，判断当前路由是否在子菜单中
      if (item.children && item.children.length) {
        const hasActiveChild = item.children.some(
          son => son.children && son.children.some(col => col.url && currentPath === col.url)
        )
        if (hasActiveChild) return true
      }

      // 特殊处理：采购模块
      if (this.isPurchase && item.module === 'purchase') {
        return true
      }

      return false
    }
  },
  created() {
    if (!this.userInfos) {
      this.getUserInfo().then(res => {
        let { code, data } = res.data
        if (code === '0') {
          this.setUserInfos(data)
        }
      })
    }
  },
  computed: {
    ...mapState('homeModule', ['userInfos']),
    getPath() {
      return this.$route.path
    },
    isPurchase() {
      return this.$route.fullPath?.includes('type=_purchase')
    },
    activeMenu() {
      return this.$route.path
    },
    getMenus() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      let userType = userInfo.userType

      // 深拷贝menuData，避免修改原始数据
      let menuDataList = JSON.parse(JSON.stringify(menuData)).filter(
        e => (this.userInfos && e.distributionShow == this.userInfos.isShow) || !e.distributionShow
      )

      // 根据userType在账号管理中添加客户或供应商路由
      menuDataList.forEach(item => {
        if (item.module === 'system' && item.children && item.children.length > 0) {
          // 找到账号管理的子菜单
          let accountMenu = item.children[0]
          if (accountMenu && accountMenu.children) {
            // 先移除已存在的客户信息和供应商信息路由，避免重复添加
            accountMenu.children = accountMenu.children.filter(
              child => child.name !== '客户信息' && child.name !== '供应商信息'
            )

            // 根据userType添加相应的路由
            if (userType === '1') {
              // 添加客户路由
              accountMenu.children.push({
                name: '客户信息',
                url: '/userInfo/index'
              })
            } else if (userType === '0') {
              // 添加供应商路由
              accountMenu.children.push({
                name: '供应商信息',
                url: '/supplierInfo/index'
              })
            }
          }
        }
      })

      return userType === '1' ? menuDataList.filter(e => !e.showFlag) : menuDataList
    }
  }
}
</script>

<style scoped lang="less">
.lida-menu-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.lida-el-menu {
  border: none !important;
  padding-top: 0 !important;
  flex: 1;
  width: 100%;

  .menu-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    vertical-align: middle;
    flex-shrink: 0;
  }

  i {
    margin-right: 8px;
    font-size: 14px;
  }

  /deep/ .el-menu-item,
  /deep/ .el-sub-menu__title {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin: 0 12px;
    border-radius: 4px;
    height: 36px;
    line-height: 36px;
    min-width: auto !important;
    display: flex !important;
    align-items: center;

    &:hover {
      background-color: #f0f7f7 !important;
      font-weight: 600;
      font-size: 14px;
      color: #48a09c !important;
    }
  }

  /deep/ .el-menu-item {
    width: 160px;
    margin: 0 10px;
  }

  // 收起状态下调整样式
  &.el-menu--collapse {
    /deep/ .el-menu-item,
    /deep/ .el-sub-menu__title {
      padding-left: 0 !important;
      padding-right: 0 !important;
      width: 40px !important;
      margin: 0 auto !important;
      justify-content: center !important;
    }

    /deep/ .el-menu-item .menu-icon,
    /deep/ .el-sub-menu__title .menu-icon {
      margin-right: 0 !important;
    }
  }

  /deep/ .el-menu-item.is-active {
    background-color: #f0f7f7 !important;
    font-weight: 600;
    font-size: 14px;
    color: #48a09c !important;
  }

  /deep/ .el-sub-menu.is-active > .el-sub-menu__title {
    font-weight: 600;
    font-size: 14px;
    color: #48a09c !important;
  }
}

.custom-popup-menu {
  position: fixed;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 12px 0;
  min-width: 200px;
  z-index: 2000;

  .popup-title {
    padding: 0 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .menu-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 8px;
      flex-shrink: 0;
    }

    i {
      margin-right: 8px;
      font-size: 14px;
    }
  }

  .popup-divider {
    height: 1px;
    background: #e5e5e5;
    margin: 8px 20px;
  }

  .popup-items {
    .popup-item {
      padding: 0 20px;
      height: 36px;
      line-height: 36px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #f0f7f7;
        font-weight: 600;
        color: #48a09c;
      }

      &.is-active {
        background-color: #f0f7f7;
        font-weight: 600;
        color: #48a09c;
      }
    }
  }
}

.menu-footer {
  display: flex;
  align-items: center;
  height: 48px;
  background-color: #fff;
  padding: 0 16px 0 28px;
  margin-bottom: 10px;

  &.collapsed {
    flex-direction: column;
    height: auto;
    padding: 0;
    border-top: none;

    .settings-btn,
    .toggle-btn {
      width: 100%;
      height: 40px;
      justify-content: center;
    }

    .toggle-btn {
      span {
        display: none;
      }
    }
  }

  .settings-btn,
  .toggle-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      opacity: 0.7;
    }

    .footer-icon {
      width: 16px;
      height: 16px;
      transition: transform 0.3s;
    }

    .is-expand-icon {
      transform: rotate(180deg);
    }

    span {
      margin-left: 8px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: left;
      font-style: normal;
    }
  }

  .settings-btn {
    flex: 0 0 auto;
  }

  .divider {
    width: 1px;
    height: 16px;
    background-color: #e6e6e6;
    margin: 0 16px;
  }

  .toggle-btn {
    flex: 1;
    justify-content: flex-end;
  }
}
</style>

<style lang="less">
// 悬浮弹出的子菜单样式（全局样式，不使用scoped）
.el-menu--popup {
  .el-menu-item {
    font-weight: 400 !important;
    font-size: 14px !important;
    color: #333333 !important;
    height: 36px !important;
    line-height: 36px !important;
    margin: 0 12px !important;
    border-radius: 4px !important;

    &:hover {
      background-color: #f0f7f7 !important;
      font-weight: 600 !important;
      color: #48a09c !important;
    }

    &.is-active {
      background-color: #f0f7f7 !important;
      font-weight: 600 !important;
      color: #48a09c !important;
    }
  }
}

// 隐藏带有特定 class 的 Element UI 弹出菜单
.hide-element-popup {
  display: none !important;
}

// 收起状态下隐藏 Element UI 默认的弹出菜单
.el-menu--collapse .el-menu--popup {
  display: none !important;
}
</style>
